import { call, put, takeEvery } from 'redux-saga/effects';
import { _CSAGENT_API_ENDPOINTS, _ECOPRO_C4C_API_ENDPOINTS, USER_ACTIVITY_LOGS } from '../../../constants/AppConstants';
import { _CALLPOSTAPI } from '../../../api/apiHandler';
import {
  fetchBOCDeviceConnectionRequest,
  fetchBOCDeviceConnectionSuccess,
  fetchBOCDeviceConnectionFailure
} from './BOCDeviceConnectionServiceSlice';
import UserActivityLogsPayload from '../../../utils/AdminPortal/UserActivityLogsPayload';
import { ISC4CSERVICEAGENT } from '../../../constants/AppMethod';

async function _BOCDeviceConnectionService(serialNumber, userId) {
  const isC4CAgent=ISC4CSERVICEAGENT()
  const endpoint = isC4CAgent ? _ECOPRO_C4C_API_ENDPOINTS.C4C_BOC_DEVICE_CONNECTION: _CSAGENT_API_ENDPOINTS.BOC_DEVICE_CONNECTION;
  const logDetails = {
    action: USER_ACTIVITY_LOGS.BOC_DEVICE_SEARCH,
    description: `Fetched BOC device details for the serial number: ${serialNumber}`
  }
  const payload = {
    "servicePortalUser": await UserActivityLogsPayload(logDetails),
    "serialNumber": serialNumber ,
    "userId": userId
  }

  return _CALLPOSTAPI(endpoint, payload)
    .then(response => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

function* fetchBOCDeviceConnectionSaga(action) {
  try {
    const { serialNumber, userId } = action.payload;
    const response = yield call(_BOCDeviceConnectionService, serialNumber, userId);
    yield put(fetchBOCDeviceConnectionSuccess(response));
  } catch (error) {
    yield put(fetchBOCDeviceConnectionFailure(error.message));
  }
}

export default function* watchFetchBOCDeviceConnectionService() {
  yield takeEvery(fetchBOCDeviceConnectionRequest.type, fetchBOCDeviceConnectionSaga);
}
